import { render, staticRenderFns } from "./FormElementUpload.vue?vue&type=template&id=05881d66"
import script from "./FormElementUpload.vue?vue&type=script&lang=js"
export * from "./FormElementUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports